<script>
import chat from "../components/chat";

export default {
  name: "auction-vessel-panel",
  props: {
    bid: Object,
    showFuelCost: Boolean,
    refreshChat: Number,
  },
  components: {
    chat,
  },
  data: function() {
    return {
      latestMessage: "",
    };
  },
  methods: {
    getDocumentById: function(id) {
      return getDocumentById(process.env.VUE_APP_SEABAY_ROOT, id);
    },
    onClick: function() {},
    isEmptyObj: function(obj) {
      return isEmptyObj(obj);
    },
    getPanelClass: function() {
      var result = "";
      if (this.isActive) {
        result += " active-vessel";
      } else if (this.activeVesselName) {
        result += "not-active";
      }
      if (this.isOwner) {
        result += " owner-viewer";
      } else {
        result += " standard-viewer";
      }
      if (!this.isOwner && (!this.activeBidders || this.isEmptyObj(this.activeBidders) || !this.activeBidders.length)) {
        result += " not-present";
      }
      if (this.isOwner) {
        result += " owner-viewer";
      } else {
        result += " not-owner-viewer";
      }
      if (this.isSmallScreen) {
        result += " small-screen";
      }
      if (this.isMobile) {
        result += " mobile-screen";
      }
      return result;
    },
    formatCurrency(input) {
      return input
        .toFixed(2)
        .replace(/\d(?=(\d{3})+\.)/g, "$&,")
        .split(".")[0];
    },
  },
  computed: {
    currency: function() {
      return this.$store.state.activeAuction.currency;
    },
    fuelPrice() {
      return this.$store.state.fuelPrice;
    },
    fuelUnit() {
      return this.$store.state.fuelUnit;
    },
    currencyFormatted: function() {
      var thisValue = this.bid.currentRate;
      var self = this;
      return self.isSmallScreen ? `${this.formatCurrency(thisValue)}` : `${this.formatCurrency(thisValue)} ${this.currency}`;
    },
    originalRateFormatted: function() {
      return `${this.formatCurrency(this.bid.bidHistory[0].rate)} ${this.currency}`;
    },
    getEstimatedDailyFuelCost() {
      var b = this.bid;
      var ecoSpeedConsumption = b.offer.Vessel.mac_fue_economicSpeedFuel;
      var rate = this.fuelPrice;
      var unit = this.fuelUnit;
      return getEstimatedDailyFuelCost(ecoSpeedConsumption, rate, unit);
    },
    fuelCostDisplay() {
      var fuelCost = this.getEstimatedDailyFuelCost;
      var self = this;
      return fuelCost ? (self.isSmallScreen ? `${this.formatCurrency(fuelCost)}` : `${this.formatCurrency(fuelCost)} ${this.currency}`) : "-";
    },
    getTotalEstimatedRate() {
      var b = this.bid;
      var fuelCostDaily = this.getEstimatedDailyFuelCost;
      if (!fuelCostDaily) {
        return null;
      } else {
        return fuelCostDaily + b.currentRate;
      }
    },
    estimatedDailyCostDisplay() {
      var b = this.bid;
      var self = this;
      if (this.getTotalEstimatedRate) {
        return self.isSmallScreen ? `${self.formatCurrency(self.getTotalEstimatedRate)}` : `${self.formatCurrency(self.getTotalEstimatedRate)} ${self.currency}`;
      } else {
        return "-";
      }
    },
    isActive: function() {
      return this.activeVesselName == this.bid.vesselName;
    },
    activeVesselName: function() {
      return this.$store.state.activeVesselName || null;
    },
    latestBidMessageId: function() {
      return this.$store.state.latestBidMessageId;
    },
    activeAuctionId: function() {
      var result = this.$store.state.activeAuction.id;
      return result;
    },
    activeBidders: function() {
      var allBidders = this.$store.state.activeAuction.activeBidders;
      if (this.isEmptyObj(allBidders)) {
        return null;
      } else {
        var id = this.bid.offerId;
        return allBidders.filter(function(x) {
          return x.associatedBids.indexOf(id) > -1;
        });
      }
    },
    userRole: function() {
      return this.$store.state.role;
    },
    isCharterer: function() {
      return this.userRole == "CHA";
    },
    isOwner: function() {
      return this.userRole == "OWN";
    },
    auctionCurrency: function() {
      return this.$store.state.activeAuction.currency;
    },
    fuelCostHoverTitle() {
      var ecoSpeedConsumption = this.bid.offer.Vessel.mac_fue_economicSpeedFuel;
      if (ecoSpeedConsumption) {
        return `Based on eco speed fuel consumption of ${ecoSpeedConsumption} m³/day`;
      } else {
        return "Unable to estimate fuel cost - There is no fuel consumption data for this vessel.";
      }
    },
    showFuelDetails() {
      return this.$store.state.activeAuction.includeFuelCost && !this.isOwner;
    },
    hideImage() {
      return ((this.$store.state.windowWidth < 1200 && !this.isOwner) || this.$store.state.windowWidth < 992) && !this.isMobile;
    },
    isSmallScreen() {
      return this.$store.state.isSmallScreen;
    },
    isMobile() {
      return this.$store.state.isMobile;
    },
    isLowestBid: function() {
      return this.bid.lowestBid;
    },
    isAuctionComplete: function() {
      return this.$store.state.activeAuction ? this.$store.state.activeAuction.status == "Complete" : false;
    },
  },
  watch: {
    bid: {
      deep: true,
      handler: function() {
        this.$forceUpdate();
      },
    },
    latestBidMessageId: {
      async handler(val) {
        var self = this;
        if (val == this.bid.offerId) {
          self.latestMessage = await self.$store.dispatch("getRequest", { controller: "chat", method: `latest`, parameters: { auctionId: self.activeAuctionId, bidId: self.bid.offerId } });
          if (!self.isActive) {
            self.$store.commit("setNewMessage", true);
          }
        }
      },
      deep: true,
    },
    isActive: function(val) {
      this.latestMessage = "";
    },
  },
};
</script>
<template>
  <div class="panel" :class="getPanelClass()" style="position:relative">
    <div class="lowest-bid-icon" v-if="isLowestBid" title="Currently lowest bid">
      <i class="fas fa-award"></i>
    </div>
    <div v-if="bid.withdrawn" class="withdrawn">
      <span>WITHDRAWN</span>
    </div>
    <div class="image-wrapper" v-if="!hideImage">
      <img style="width:100%;height:100%;" :src="getDocumentById(bid.offer.VesselImageId)" v-on:error="$event.target.src = '/noImageAvailable.png'" />
    </div>
    <div class="vessel-details" :class="[hideImage ? 'image-hidden' : '']" v-if="showFuelDetails">
      <div class="row">
        <div class="col-12">
          <div style="white-space:nowrap;text-overflow: ellipsis;overflow: hidden;">
            <span v-if="!isOwner" class="active-bidder">
              <span v-if="!activeBidders || !activeBidders.length" title="Bidder is not currently present" class="fa fa-user not-active"></span>
              <span v-else title="Bidder is currently present" class="fa fa-user active"></span>
            </span>
            <span class="name">{{ bid.vesselName }}</span>
            <div class="transition-wrapper">
              <transition name="bounce" v-if="!isActive">
                <div class="speech-bubble-wrapper" v-if="latestMessage != ''">
                  <i class="fas fa-comment icon-shake" style="color: #004996;margin-left:3px;"></i><i class="speech-bubble">{{ latestMessage }}</i>
                </div>
              </transition>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div :class="[isSmallScreen ? 'col-6' : 'col-4']">
          <div style="padding-left:5px;">
            <label style="font-size:11px;margin-bottom:0px;width:100%">Current Bid</label>
            <span title="Current Bid" class="rate" style="width:100%">{{ currencyFormatted }}</span>
            <span v-if="!isSmallScreen" title="Initial Offer" style="font-size:11px;display:block;margin-top:-2px;">({{ originalRateFormatted }})</span>
          </div>
        </div>
        <div :class="[isSmallScreen ? 'col-6' : 'col-4']">
          <div style="padding-right:5px;" :title="fuelCostHoverTitle">
            <label style="font-size:11px;margin-bottom:0px;width:100%">Fuel Cost (est)</label>
            <span class="original-rate">{{ fuelCostDisplay }}</span>
          </div>
        </div>
        <div class="col-4" v-if="!isSmallScreen">
          <div style="padding-right:5px;" :title="fuelCostHoverTitle">
            <label style="font-size:11px;margin-bottom:0px;width:100%"><span v-if="!isSmallScreen">Total (est)</span><span v-else>Total</span></label>
            <span class="original-rate">{{ estimatedDailyCostDisplay }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="vessel-details vessel-details-owner" :class="[hideImage ? 'image-hidden' : '']" v-else>
      <div class="row">
        <div class="col-12">
          <div style="white-space:nowrap;text-overflow: ellipsis;overflow: hidden;">
            <span v-if="!isOwner" class="active-bidder">
              <span v-if="!activeBidders || !activeBidders.length" title="Bidder is not currently present" class="fa fa-user not-active"></span>
              <span v-else title="Bidder is currently present" class="fa fa-user active"></span>
            </span>
            <span class="name">{{ bid.vesselName }}</span>
            <div class="transition-wrapper">
              <transition name="bounce" v-if="!isActive">
                <div class="speech-bubble-wrapper" v-if="latestMessage != ''">
                  <i class="fas fa-comment icon-shake" style="color: #004996;margin-left:3px;"></i><i class="speech-bubble">{{ latestMessage }}</i>
                </div>
              </transition>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <div style="padding-left:5px;">
            <label style="font-size:11px;margin-bottom:0px;width:100%">Current Bid</label>
            <span title="Current Bid" class="rate" style="width:100%">{{ currencyFormatted }}</span>
          </div>
        </div>
        <div class="col-6">
          <div style="padding-left:5px;">
            <label style="font-size:11px;margin-bottom:0px;width:100%">Original Offer</label>
            <span title="Original Bid" class="rate" style="width:100%">{{ originalRateFormatted }}</span>
          </div>
        </div>
      </div>
    </div>
    <div v-if="isMobile && isActive">
      <chat :inlineChat="true" :refreshChat="refreshChat"></chat>
    </div>
  </div>
</template>
<style scoped>
.image-wrapper {
  display: inline-block;
}
.vessel-list-wrapper .not-owner-viewer .image-wrapper {
  width: 120px;
  height: 90px;
}
.vessel-list-wrapper .owner-viewer .image-wrapper {
  width: 120px;
  height: 75px;
}
.vessel-details {
  text-overflow: ellipsis;
  overflow: hidden;
}
.vessel-list-wrapper .vessel-details:not(.image-hidden) {
  width: calc(100% - 120px);
  float: right;
}
.vessel-list-wrapper .image-hidden {
  width: 100%;
}

.name {
  white-space: nowrap;
}
.vessel-list-wrapper .vessel-details .name {
  color: #004996;
  font-size: 12px;
}

.vessel-details-owner .name {
  font-size: 16px !important;
}
.vessel-details .rate {
  font-size: 12px;
  font-weight: bold;
  color: #006400;
}
.small-screen .rate,
.small-screen .current-rate {
  font-size: 11px !important;
}

.vessel-list-wrapper .vessel-panel:first-child img {
  border-top-left-radius: 5px;
}
.vessel-list-wrapper .vessel-panel:last-child img {
  border-bottom-left-radius: 5px;
}
.vessel-list-wrapper .vessel-panel :first-child {
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}
.vessel-list-wrapper .vessel-panel:last-child {
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
}

.active-vessel img {
  border-radius: 0px !important;
}
.active-vessel.mobile-screen {
  -webkit-box-shadow: 0px 0px 19px 0px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 0px 0px 19px 0px rgba(0, 0, 0, 0.75);
  box-shadow: 0px 0px 19px 0px rgba(0, 0, 0, 0.75);
  z-index: 999;
  background-color: white;
}
#message-part-wrapper .active-vessel {
  -webkit-box-shadow: 0px 0px 19px 0px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 0px 0px 19px 0px rgba(0, 0, 0, 0.75);
  box-shadow: 0px 0px 19px 0px rgba(0, 0, 0, 0.75);
  transform: scale(1.05);
  z-index: 999;
  background-color: white;
}
.not-active,
.not-present {
  opacity: 0.6;
}
.bounce-enter-active {
  animation: bounce-in 0.5s;
}
.speech-bubble-wrapper {
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline;
}
.speech-bubble {
  color: white;
  border-radius: 5px;
}

.transition-wrapper {
  display: inline;
}
.speech-bubble {
  color: #004996;
  border-radius: 0.4em;
  padding: 2px;
  font-size: 12px;
  overflow-wrap: break-word;
  margin: auto;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.5);
  }
  100% {
    transform: scale(1);
  }
}
.fa-user.active {
  color: rgb(144, 238, 144);
}
.fa-user.not-active {
  color: black;
}
.circle {
  position: absolute;
  top: 5px;
  display: inline-block;
  margin-left: 5px;
  cursor: pointer;
}
.withdrawn {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  text-align: center;
  background-color: rgba(255, 255, 255, 0.8);
}
.withdrawn > span {
  color: red;
  display: block;
  font-weight: bold;
  transform: rotate(-20deg);
}
.vessel-list-wrapper .owner-viewer .withdrawn > span {
  line-height: 75px;
}
.vessel-list-wrapper .not-owner-viewer .withdrawn > span {
  line-height: 90px;
}
.original-rate {
  font-weight: bold;
  color: #006400;
  font-size: 12px;
}
.small-screen .original-rate {
  font-size: 11px;
}
.active-bidder {
  margin-right: 5px;
  margin-left: 5px;
  cursor: pointer;
}
.lowest-bid-icon {
  position: absolute;
  top: -10px;
  right: 10px;
  height: 40px;
  width: 40px;
  background-color: white;
  border: 3px solid gold;
  border-radius: 9999px;
  text-align: center;
}
.lowest-bid-icon i {
  color: gold;
  font-size: 24px;
  padding-top: 3px;
}
</style>
